import { personColors, type AgeProfile, type PersonColor, type Role } from '@shh/shared';
import { settingsText } from '../i18n/settings';

/** How people are described in the UI – in words, not technical profiles. */
export type PersonKind = 'parent' | 'teen' | 'kid' | 'little';

export const personKinds: { value: PersonKind; label: string; description: string }[] = (
  ['parent', 'teen', 'kid', 'little'] as const
).map((value) => ({ value, ...settingsText.kinds[value] }));

export function kindToProfile(kind: PersonKind): { role: Role; ageProfile: AgeProfile } {
  switch (kind) {
    case 'parent':
      return { role: 'parent', ageProfile: 'teen' };
    case 'teen':
      return { role: 'teen', ageProfile: 'teen' };
    case 'kid':
      return { role: 'kid', ageProfile: 'kid' };
    case 'little':
      return { role: 'kid', ageProfile: 'picture' };
  }
}

export const profileToKind = (role: Role, ageProfile: AgeProfile): PersonKind =>
  role === 'parent'
    ? 'parent'
    : role === 'teen'
      ? 'teen'
      : ageProfile === 'picture'
        ? 'little'
        : 'kid';

export const colorNames: Record<PersonColor, string> = settingsText.colors;

/** The next colour nobody uses yet (so new people never look alike). */
export function nextFreeColor(used: PersonColor[]): PersonColor {
  return (
    personColors.find((c) => !used.includes(c)) ?? personColors[used.length % personColors.length]!
  );
}
